import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux';
import WalletConnectComponent from './../WalletConnectComponent';
import uuid from 'react-uuid';
import * as signalR from '@microsoft/signalr'
import ApiService from '../Services/ApiService';
import AlertService from '../Services/AlertService';
import Main from '../modules/main/_Main';
import { TRON_PLATFORM_TYPE } from '../Constants/MainKeys';
import { addPageSpinner, removePageSpinner } from '../Store/Reducers/spinnersReducer';
import { setToken } from '../Store/Reducers/mainReducer';
import { useParams } from 'react-router-dom';
import TransactionExpiredModal from '../Components/TransactionExpired/TransactionExpiredModal';
import Footer from '../modules/Footer';
import TronComponent from '../TronComponent';

export default function Home() {

  const { token } = useParams();
  const API_URL_KEY = import.meta.env.VITE_API_URL_KEY || "";
  const dispatch = useDispatch();
  const [globalConnection, setGlobalConnection] = useState(null);
  const [cryllexChains, setCryllexChains] = useState([]);

  const [selectedChain, setSelectedChain] = useState(null);
  const [selectedToken, setSelectedToken] = useState(null);

  const [countries, setCountries] = useState([]);
  const [activeTab, setActiveTab] = useState(1);

  useEffect(() => {
    getCountries();
    getChains();
    return () => {
      setCountries([]);
      setCryllexChains([]);
    }
  }, [])

  const getCountries = () => {
    ApiService.getCountries().then(response => {
      if (response && response.data) {
        setCountries(response.data);
      }
    }).catch(error => AlertService.alert("error", error));
  }

  const getChains = () => {
    const spinnerId = uuid();
    dispatch(addPageSpinner(spinnerId));
    ApiService.getChains().then(response => {
      if (response && response.data && response.data.data) {
        setCryllexChains(response.data.data)
      }
    }).catch(error => AlertService.alert("error", error)).finally(() => {
      dispatch(removePageSpinner(spinnerId));
    })
  }

  useEffect(() => {
    localStorage.removeItem("wagmi.store");
    localStorage.removeItem("wagmi.recentConnectorId");
    localStorage.removeItem("@w3m/connected_connector");
    indexedDB.deleteDatabase("WALLET_CONNECT_V2_INDEXED_DB");
    sessionStorage.clear();
    deleteAllCookies();
  }, [])

  useEffect(() => {
    if (token) {
      dispatch(setToken(token));
      signal_start();
    }
  }, [token])

  const deleteAllCookies = () => {
    document.cookie.split(';').forEach(cookie => {
      const eqPos = cookie.indexOf('=');
      const name = eqPos > -1 ? cookie.substring(0, eqPos) : cookie;
      document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT';
    });
  }

  const signal_start = async () => {
    // if (!user) { return false; }
    const connection = new signalR.HubConnectionBuilder()
      .withUrl(`${API_URL_KEY}/paymenthub`)
      .withAutomaticReconnect()
      .configureLogging(signalR.LogLevel.None)
      .build();
    connection.serverTimeoutInMilliseconds = 1000 * 60 * 10;
    try {
      await connection.start();
      await signal_init(connection);
      await signal_update(connection);
      console.assert(connection.state === signalR.HubConnectionState.Connected);
      console.log("SignalR Connected.");
      setGlobalConnection(connection);
      connection.onclose(() => {
        setTimeout(() => signal_start(), 1000);
      });
    } catch (err) {
      console.assert(connection.state === signalR.HubConnectionState.Disconnected);
      setTimeout(() => signal_start(), 1000);
    }
  };

  const signal_init = async (connection) => {
    try {
      await connection.invoke("init", token);
    } catch (err) {
      setTimeout(() => { signal_init(); }, 1000);
    }
  }

  const signal_update = async (connection) => {
    try {
      await connection.invoke("update", token);
    } catch (err) {
      setTimeout(() => { signal_update(); }, 1000);
    }
  }

  const setMainContent = (cryllexChains = []) => {
    return <Main
      cryllexChains={cryllexChains}
      connection={globalConnection}
      signal_update={signal_update}
      selectedToken={selectedToken}
      selectedChain={selectedChain}
      onSetNetwork={onSetNetwork}
      onSetCrypto={onSetCrypto}
      countries={countries}
      setSelectedChain={setSelectedChain}
      setSelectedToken={setSelectedToken}
      activeTab={activeTab}
      setActiveTab={setActiveTab}
    />
  }

  const onSetNetwork = async (chain) => {
    if (!chain) { return false; }
    const spinnerId = uuid();
    dispatch(addPageSpinner(spinnerId));
    setSelectedToken(null);
    ApiService.onSetNetwork({ networkId: chain?.id }).then(() => {
      setSelectedChain(chain);
    }).catch(error => AlertService.alert("error", error)).finally(() => {
      dispatch(removePageSpinner(spinnerId));
    })
  }

  const onSetCrypto = async (_token) => {
    if (!_token) { return false; }
    const spinnerId = uuid();
    dispatch(addPageSpinner(spinnerId));
    ApiService.onSetCrypto({ cryptoCurrencyId: _token?.id, name: _token?.slug }).then(() => {
      setSelectedToken(_token);
      setActiveTab(3);
    }).catch(error => AlertService.alert("error", error)).finally(() => {
      dispatch(removePageSpinner(spinnerId));
    })
  }

  return (
    <div>
      {/* <AuthModal /> */}

      <div>
        {(() => {
          switch (selectedChain?.platformType) {
            case TRON_PLATFORM_TYPE:
              return (
                <WalletConnectComponent>
                  <TronComponent>
                    {setMainContent(cryllexChains)}
                  </TronComponent>
                </WalletConnectComponent>
              )
            default:
              return (
                <WalletConnectComponent>
                  {setMainContent(cryllexChains)}
                </WalletConnectComponent>
              )
          }
        })()}
      </div>

      {/* {
        cryllexChains && cryllexChains.length && walletConnectChains && walletConnectChains.length ?
        <div>
          {(() => {
            switch (selectedChain?.platformType) {
              case ETHEREUM_PLATFORM_TYPE:
                return (
                  <WalletConnectComponent>
                    {setMainContent(cryllexChains)}
                  </WalletConnectComponent>
                );
              case AVALANCHE_PLATFORM_TYPE:
                return (
                  <WalletConnectComponent>
                    {setMainContent(cryllexChains)}
                  </WalletConnectComponent>
                );
              case SOLANA_PLATFORM_TYPE:
                return (
                  <SolanaComponent>
                    {setMainContent(cryllexChains)}
                  </SolanaComponent>
                );
              case TRON_PLATFORM_TYPE:
                return (
                  <TronComponent>
                    {setMainContent(cryllexChains)}
                  </TronComponent>
                );
              default:
                return (
                  <WalletConnectComponent>
                    {setMainContent(cryllexChains)}
                  </WalletConnectComponent>
                );
            }
          })()}
        </div>
        : null
      } */}
      <Footer chains={cryllexChains} />
    </div>
  )
}
